import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getServices } from '../../../httpClient/Requests/Api/XTRF/system'
import axios from 'axios'
import { PrefixType } from '../../interfaces/Prefix'
import { getTempoServices } from '../../../httpClient/Requests/Api/TEMPO/system'
import { OtherLookupFormat, OtherLookupState } from '../../interfaces/OtherLookupState'

export const initialState: OtherLookupState = {
    data: [],
    loading: false,
    error: null,
}

export const fetchServices = (prefix: PrefixType) =>
    createAsyncThunk(`${prefix}/services/fetchServices`, async (_: void, { signal }) => {
        const source = axios.CancelToken.source()
        signal.addEventListener('abort', () => {
            source.cancel()
        })
        let services: OtherLookupFormat[] = []
        if (prefix.includes('XTRF')) {
            const response = await getServices<OtherLookupFormat[]>()
            services = response.data
        } else if (prefix === 'MEMSOURCE') {
            // TODO (?)
        } else if (prefix === 'TEMPO') {
            const response = await getTempoServices<OtherLookupFormat[]>()
            services = response.data
        }
        return services
    })

const servicesSlice = (prefix: PrefixType) =>
    createSlice({
        name: `${prefix}/services`,
        initialState,
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(fetchServices(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchServices(prefix).fulfilled, (state, action) => ({
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            }))
            builder.addCase(fetchServices(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

const services = (prefix: PrefixType) => servicesSlice(prefix).reducer

export default services
